import { BogeyState } from "../../enum/BogeyState";
import { Time } from "../../lib/Time";
import Vector2 from "../../math/Vector2";
import SPBogey from "../SPBogey";
import SPPlayer from "../SPPlayer";

export default class Diver extends SPBogey {

    hp: number = 1;
    maxHP: number = 1;
    fireRate: number = 0;
    xpReward: number = 2;
    accelerationForce: number = 128;

    AttackUpdate(player: SPPlayer): void {
        if (player.isDead) {
            this.changeState(BogeyState.Wander);
            return;
        }

        if (this.fireRateTimer > 0) {
            this.fireRateTimer -= Time.deltaTime;

            if (this.fireRateTimer <= 0) this.fireRateTimer = 0;
        }

        const targetPos = player.transform.position;
        const targetRot = player.transform.position.sub(this.transform.position).normalized;
        this.transform.rotation = Vector2.lerp(this.transform.rotation, targetRot, Math.PI * Time.deltaTime);

        if (Vector2.distance(player.transform.position, this.transform.position) <= 256 && Math.abs(this.transform.rotation.angle - targetRot.angle) <= 0.1745) {
            this.ShootAt(player.transform);
        }

        this.acceleration = targetPos.sub(this.transform.position).normalized.scale(this.accelerationForce);
    }

}